// at runtime this will be looked up and replaced with a value that matches T
export function lookupValue<T = string>(key: string): T {
    return (`_${key}` as unknown) as T;
}
